module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as1503-ffd54237d5dff87287233c7c34859eb3.jpg";